// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-calendar abbr {
  display: none;
}
.holiday {
  background: red !important;
  color: white !important;
}

.leave-dates {
  background-color: #ff6933 !important;
  /* border-color: #ff6933 !important; */
  color: #fff;
}
.holidayleave {
  background: red !important;
  color: white !important;
  border-radius: 50%;
}

.leave-datesleave {
  background: orange !important;
  color: white !important;
  border-radius: 50%;
}

.compensatory-leave {
  background: #9b59b6 !important;
  color: white !important;
}

.compensatory-tooltip {
  cursor: pointer;
}

.compensatory-used-date {
  background: #d5d5d5 !important;
  color: #999 !important;
  text-decoration: line-through;
  border-radius: 50%;
}
/* Sundays - Red */
.react-calendar__tile.sunday-holiday {
  background-color: #df1a42 !important;
  color: white !important;
  pointer-events: none;
}

/* Non-working Saturdays - Yellow */
.react-calendar__tile.saturday-holiday {
  background-color: #df1a42 !important;
  color: #333 !important;
  pointer-events: none;
}

/* Public Holidays */
.react-calendar__tile.holiday {
  background-color: #df1a42 !important;
  color: white !important;
}

/* Approved Leaves */
.react-calendar__tile.leave-dates {
  background-color: #ff6933 !important;
  color: white !important;
}

/* Compensatory Leave */
.react-calendar__tile.compensatory-leave {
  background-color: #d3ff21 !important;
  color: #000000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Leaverequestapprovals.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":[".react-calendar abbr {\r\n  display: none;\r\n}\r\n.holiday {\r\n  background: red !important;\r\n  color: white !important;\r\n}\r\n\r\n.leave-dates {\r\n  background-color: #ff6933 !important;\r\n  /* border-color: #ff6933 !important; */\r\n  color: #fff;\r\n}\r\n.holidayleave {\r\n  background: red !important;\r\n  color: white !important;\r\n  border-radius: 50%;\r\n}\r\n\r\n.leave-datesleave {\r\n  background: orange !important;\r\n  color: white !important;\r\n  border-radius: 50%;\r\n}\r\n\r\n.compensatory-leave {\r\n  background: #9b59b6 !important;\r\n  color: white !important;\r\n}\r\n\r\n.compensatory-tooltip {\r\n  cursor: pointer;\r\n}\r\n\r\n.compensatory-used-date {\r\n  background: #d5d5d5 !important;\r\n  color: #999 !important;\r\n  text-decoration: line-through;\r\n  border-radius: 50%;\r\n}\r\n/* Sundays - Red */\r\n.react-calendar__tile.sunday-holiday {\r\n  background-color: #df1a42 !important;\r\n  color: white !important;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Non-working Saturdays - Yellow */\r\n.react-calendar__tile.saturday-holiday {\r\n  background-color: #df1a42 !important;\r\n  color: #333 !important;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Public Holidays */\r\n.react-calendar__tile.holiday {\r\n  background-color: #df1a42 !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Approved Leaves */\r\n.react-calendar__tile.leave-dates {\r\n  background-color: #ff6933 !important;\r\n  color: white !important;\r\n}\r\n\r\n/* Compensatory Leave */\r\n.react-calendar__tile.compensatory-leave {\r\n  background-color: #d3ff21 !important;\r\n  color: #000000 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
